module.exports = __webpack_public_path__ + "static/media/MUSEM.d84ec4dc.svg";